import { put } from 'redux-saga/effects'
import { fetchCustomButtonsByCompanyAction } from '../../handles'
import { FetchCustomButtonResponse, fetchCustomButtons } from '../_http/custom-button'

export function* fetchCustomButtonsByCompanySaga(action: ReturnType<typeof fetchCustomButtonsByCompanyAction.request>) {
  try {
    const { companyId, ownerId } = action.payload
    const response: FetchCustomButtonResponse = yield fetchCustomButtons({ companyId, ownerId })
    yield put(fetchCustomButtonsByCompanyAction.success({ customButtons: response.customButtons }))
  } catch (error) {
    yield put(fetchCustomButtonsByCompanyAction.failure())
  }
}
